import React from 'react';
import { Link, useNavigate, useLocation } from "react-router-dom";
import instagram from "../../assets/images/instagram-icon.svg";
import facebook from "../../assets/images/facebook-icon.svg";
import pinterest from "../../assets/images/pinterest-icon.svg";
import tiktok from "../../assets/images/tiktok-icon.svg";
import footerLogoSign from "../../assets/images/footer-logo-sign.svg";
import cards from "../../assets/images/card-icons.svg";
import { FacebookURL, InstagramURL, PinterestURL, TikTokURL } from '../../constants/userConstant';
import { cmsRoutes } from '../../utils/helper';
import { toast } from 'react-toastify';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // Hide the newsletter sign-up + social links on the checkout page only
  // (client feedback sheet 3) to keep checkout focused.
  const hideNewsletter = location.pathname.toLowerCase().includes("/checkout");

  // Open Klaviyo newsletter popup
  const handleOpenNewsletterPopup = () => {
    if (window._klOnsite) {
      window._klOnsite.push(['openForm', 'RewLHE']);
      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('klaviyoForms', { detail: { type: '$opened', formId: 'RewLHE' } }));
      }, 500);
    } else {
      // Fallback if Klaviyo is blocked or failed to load
      console.warn('[Footer] Klaviyo not loaded. User may have ad blocker enabled.');
      toast.warning('Please disable your ad blocker to sign up for our newsletter, or email us at hello@memorised.com.au');
    }
  };
  
  const scrollToTestimonials = () => {
    navigate("/", { state: { scrollToTestimonials: true } });
  };

  const footerLinks = [
    { ...cmsRoutes.about, name: "About" },
    { id: null, name: "FAQs", path: "/faq" },
    { ...cmsRoutes.shipping, name: "Shipping and Delivery" },
    { ...cmsRoutes.privacy, name: "Privacy Policy" },
    { ...cmsRoutes.terms, name: "Terms of Service" },
    { id: null, name: "Contact Us", path: "/contact-us" },
    { id: null, name: "Reviews", onClick: scrollToTestimonials },
    { id: null, name: "Blog", path: "/blogs" },
  ];
  
  return (
    <div className="footer">
      <div className="footer_top">
        <div className="container">
          <div className="footer-row">
            {!hideNewsletter && (
            <div className="footercol-left">
              <h6 className="mb-2">Newsletter</h6>
              <div className="newsletter-div ">
                    <button 
                      onClick={handleOpenNewsletterPopup}
                      className="newsletter-trigger-btn "
                      
                      
                    >
                     Subscribe and get $20 off 
                    </button>
                    your first order, plus 
                   memory-keeping tips, updates & special offers
              </div>

              <div className='social-link-ft mt-5'>
              <h6 className="mb-2">STAY CONNECTED WITH US</h6>
              <p>Follow us for updates, inspiration, and special offers.</p>
              <ul className='social-list'>
              <li>
                <a href={InstagramURL} target="_blank" rel="noopener">
                  <img src={instagram} alt="Instagram" />
                </a>
              </li>
              <li>
                <a href={FacebookURL} target="_blank" rel="noopener">
                  <img src={facebook} alt="Facebook" />
                </a>
              </li>
              <li>
                <a href={PinterestURL} target="_blank" rel="noopener">
                  <img src={pinterest} alt="Pinterest" />
                </a>
              </li>
              <li>
                <a href={TikTokURL} target="_blank" rel="noopener">
                  <img src={tiktok} alt="TikTok" />
                </a>
              </li>
              </ul>
              </div>

            </div>
            )}
            <div className="footercol-right">
              <h6 className='mb-2'>Quick Links</h6>
              <nav className="footerlinks">
                <ul>
                  {footerLinks.map((link, index) => (
                    <li key={index}>
                      {link.onClick ? (
                        <a onClick={link.onClick} className="nav-button">
                          {link.name}
                        </a>
                      ) : (
                        <Link to={link.path}>{link.name}</Link>
                      )}                   
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
          <div className="ft-copyright-row">
            <div>
              <img src={footerLogoSign} alt="Footer Logo" />
              <p className="mb-0 mt-2"><span className="copyrt-text">&copy;</span> Memorised {new Date().getFullYear()}</p>
            </div>
            <div className="cards-col align-self-end">
              <img src={cards} alt="Payment Cards" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
